import { Box, Flex } from 'reflexbox/styled-components';
import styled, { css } from 'styled-components';

const H1 = styled.h1`
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  color: var(--main-black);

  @media (max-width: 767px) {
    text-align: center;
  }
`;

const H5 = styled.h5`
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: var(--secondary-gray);

  @media (max-width: 767px) {
    text-align: center;
  }
`;

const ErrorText = styled(Box)`
  color: #ff4747;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

const Wrap = styled(Flex)`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 70%;
`;

const Title = styled.h1`
  font-size: 42px;
  text-align: center;
`;

const Description = styled(Box)`
  font-size: 18px;
  max-width: 260px;
  line-height: 24px;
  text-align: center;
`;

const ModalConfirmEmailIcon = styled.img`
  width: 30px;
  height: auto;
  margin: 15px auto 0;
`;

const ForgotPass = styled(Box)`
  //margin-top: 30px;
  font-size: 14px;
  color: var(--secondary-gray);
  text-align: right;

  span {
    cursor: pointer;
  }
`;

const ButtonIcon = styled.img`
  margin-right: 25px;
  width: 18px;
  height: auto;
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);

  ${(props) =>
    props.social &&
    css`
      margin-right: 15px;

      @media (max-width: 768px) {
        width: 24px;
        height: 24px;
      }
    `}

  ${(props) =>
    props.insideHeaderMenu &&
    css`
      margin-right: 0;
    `}

  ${({ size }) =>
    size &&
    css`
      width: ${size};
      height: ${size};
    `}
`;

const Caption = styled(Box)`
  color: var(--secondary-gray);
  font-size: 13px;

  [data-theme='dark'] & {
    color: var(--main-black);
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.active &&
    css`
      color: #4c96f7;
      border-bottom: solid 2px #4c96f7;
    `}

  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
      line-height: 22px;
    `}

  span {
    cursor: pointer;
    color: #fff;
    font-size: 19px;
  }

  ${(props) =>
    props.blueSmall &&
    css`
      span {
        cursor: text;
        font-size: 13px;
        color: #007aff;
      }
    `}

  ${(props) =>
    props.blueSpan &&
    css`
      background: red;
      span {
        color: #007aff;
      }
    `}
  
  
  ${(props) =>
    props.flex &&
    css`
      display: flex;
      justify-content: space-between;
    `}
  
  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}
  
  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  
  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize}px;
    `}
  
  ${(props) =>
    props.double &&
    css`
      display: flex;
      justify-content: space-between;
    `}
  
  ${(props) =>
    props.hidden &&
    css`
      visibility: hidden;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.menuItem &&
    css`
      cursor: pointer;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        bottom: -7px;
        left: 0;
        width: 100%;
        height: 2px;
        background: transparent;
      }
    `}
  
  ${(props) =>
    props.activeMenuItem &&
    css`
      font-weight: bold;
      color: var(--main-black);

      &:after {
        background: #ffbc49;
      }
    `}

  ${(props) =>
    props.linkBio &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}

  ${(props) =>
    props.preview &&
    css`
      margin-right: 10px;
      color: var(--main-black);
      max-width: 280px;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  ${(props) =>
    props.insideModal &&
    css`
      position: relative;
      margin: 0;
      flex-grow: 1;
      flex-basis: 100%;
      text-align: center;
      //margin-bottom: 20px;

      span {
        color: var(--main-black);
        text-decoration: underline;
      }
    `}

  

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}


  ${(props) =>
    props.productItem &&
    css`
      margin-right: 10px;
      display: flex;
      padding: 5px 15px;
      cursor: pointer;
      color: var(--main-black);
      line-height: 1.4;
      align-items: center;
    `}

  ${(props) =>
    props.customItem &&
    css`
      font-size: 14px;
      padding: 10px;
    `}
  
  ${(props) =>
    props.productActiveItem &&
    css`
      font-weight: bold;
      color: #57d691;
      background: #f8f2e7;
      border-radius: 8px;
    `}

  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}

  ${(props) =>
    props.designButton &&
    css`
      width: 125px;
      flex: none;

      @media (max-width: 767px) {
        width: 100%;
        margin-bottom: 12px;
      }
    `}

  ${(props) =>
    props.insideMusic &&
    css`
      position: relative;
      margin-top: 30px;

      @media (max-width: 767px) {
        margin-top: 0;
      }
    `}

  ${(props) =>
    props.previewLink &&
    css`
      margin-top: -25px;
      padding-bottom: 25px;
    `}

  ${(props) =>
    props.isText &&
    css`
      color: var(--main-black);

      span {
        margin-left: 4px;
        font-size: 13px;
        color: var(--main-black);
        font-weight: normal;
        cursor: default;
      }
    `}

  ${(props) =>
    props.default &&
    css`
      margin: 0 0 8px;
      font-weight: bold;
      color: var(--main-black);
    `}

  ${(props) =>
    props.uppercase &&
    css`
      text-transform: uppercase;
    `}
`;

const CustomSpan = styled.span`
  cursor: pointer;
  font-size: 19px;

  @media (max-width: 480px) {
    display: none;
  }

  ${(props) =>
    props.color &&
    css`
      color: ${props.color} !important;
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize} !important;
    `}
`;

export const CaptionContainer = styled(Box)`
  display: flex;
  align-items: center;

  ${(props) =>
    props.position &&
    css`
      position: ${props.position};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}


  ${(props) =>
    props.cursor &&
    css`
      cursor: ${props.cursor};
    `}
`;

export { ButtonIcon, Caption, CustomSpan, Description, ErrorText, ForgotPass, H1, H5, ModalConfirmEmailIcon, Title, Wrap };
